export const isEdge = (() => {
  if (typeof window === 'undefined') {
    return false
  } else {
    const isEdge = Object.hasOwn(window, 'StyleMedia')
    return isEdge
  }
})()
